export default {
  header: {
    menus: {
      about: 'Sobre',
      members: 'Membros',
      events: {
        title: 'Eventos',
        dropdown: {
          colloquia: {
            title: 'Colóquios',
            summary: 'Encontros internacionais temáticos',
          },
          seminary: {
            title: 'Seminários',
            summary: 'Seminários regulares já apresentados pelos integrantes da rede',
          },
        }
      },
      publications: {
        title: 'Publicações',
        dropdown: {
          articles: {
            title: 'Artigos',
            summary: 'Artigos sobre mitocrítica publicados pelos membros da Rede Pachamama',
          },
          books: {
            title: 'Livros',
            summary: 'Livros sobre mitocrítica publicados pelos membros da Rede Pachamama',
          },
          magazines: {
            title: 'Revistas',
            summary: 'Revistas vinculadas à Rede Pachamama',
          },
        },
      },
      talkToUs: 'Fale conosco'
    },
    beOneOfUs: 'SEJA UM DE NÓS',
  },
  dropdown: {
    qrCodeDesc: 'Escaneie o QR Code  ou mande uma mensagem pelo gmail abaixo para fazer contato conosco',
  },
  footer: {
    title: 'Ainda ficou com dúvidas? Entre em contato conosco',
    menus: {
      about: 'Sobre',
      members: 'Membros',
      events: {
        title: 'Eventos',
        colloquia: 'Colóquios',
        seminary: 'Seminários',
      },
      publications: {
        title: 'Publicações',
        articles: 'Artigos',
        books: 'Livros',
        magazines: 'Revistas',
      },
      talkToUs: 'Fale conosco'
    },
    beOneOfUs: 'SEJA UM DE NÓS',
    copy: '2024 Pachamama. todos os direitos reservados',
  },
};